angular.module('bmsApp.directives')
	.directive('noteFormAddon', function ($log,
										  $timeout,
										  FileSvc) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				model: '=',
				api: '='
			},
			templateUrl: 'ng/notes/directives/NoteFormAddon/NoteFormAddon.html',
			controller: function ($scope,
								  $q,
								  ConfigService,
								  NoteSvc) {

				var self = $scope.NoteFormAddonCtrl = {
					loading: true,
					options: {},
					methods: {
						init: function () {
							self.config = ConfigService.config;
							$scope.api = $scope.api || {};
							// create reference to model and api
							self.note = $scope.model;
							self.api = $scope.api;
							angular.extend(self.api, {
								isNoteFilled: self.methods.isNoteFilled
							});
							self.methods.disableSubmit();
							// default note attributes (expect to fail if no note object passed to directive)
							angular.extend(self.note, {
								note_type: null,
								subject: '',
								note: '',
								uploaded_attachments: [],
								removed_attachments: []
							}, self.note);
							self.methods.loadOptions()
								.then(function () {
									self.methods.enableSubmit();
									self.loading = false;
								});
						},
						loadOptions: function () {
							return $q.all([
								NoteSvc.noteTypeOptions()
									.then(function (response) {
										self.options.noteType = response.data.options;
									})
							]);
						},
						isNoteFilled: function () {
							var note = self.note;
							// if any of the fields are added we want to add the note
							var fields = [
								(angular.isObject(note.note_type)),
								(angular.isString(note.subject) && note.subject.length > 0),
								(angular.isString(note.note) && note.note.length > 0),
								(note.uploaded_attachments.length > 0)
							];
							return fields.indexOf(true) >= 0;
						},
						disableSubmit: function () {
							$timeout(function () {
								$scope.$apply(function () {
									$scope.api.submittable = false;
								});
							});
						},
						enableSubmit: function () {
							$timeout(function () {
								$scope.$apply(function () {
									$scope.api.submittable = true;
								});
							});
						}
					},
					dropzone: {
						config: {
							url: '/api/file/upload',
							parallelUploads: 3,
							maxFileSize: 30,
							addRemoveLinks: true,
							eventHandlers: {
								success: function (file, response) {
									file.serverFilepath = response.filepath;
									self.note.removed_attachments = _.without(self.note.removed_attachments, file.serverFilepath);
									if (!_.contains(self.note.uploaded_attachments, file.serverFilepath)) {
										self.note.uploaded_attachments.push(file.serverFilepath);
									}
									$timeout(function () {
										$scope.$apply();
									}, 0);
								},
								processing: function (event) {
									self.methods.disableSubmit();
								},
								queuecomplete: function () {
									self.methods.enableSubmit();
								},
								removedfile: function (file) {
									self.methods.disableSubmit();
									FileSvc.delete(file.serverFilepath)
										.then(function (response) {
											self.note.uploaded_attachments = _.without(self.note.uploaded_attachments, file.serverFilepath);
											if (!_.contains(self.note.removed_attachments, file.serverFilepath)) {
												self.note.removed_attachments.push(file.serverFilepath);
											}
											self.methods.enableSubmit();
											$log.log('Dropzone file removed');
										}, function (error) {
											$log.error('Failed to remove dropzone file: ' + error);
										});
								}
							}
						}
					}
				};

				self.methods.init();

			}
		}
	});
